// import ContactForm from "../../components/details/contactForm";
// import ListingCard from "../../components/details/listingCard";
// import MachineDetails from "../../components/details/machineDetails";
// import Footer from "../../components/layout/footer";
// import Header from "../../components/layout/header";
// import Banner from "../../components/search/banner";
// import SimilarMachines from "../../components/search/similarMachines";

// const Details = () => {
//   return (
//     <>
//       <Header />
//       <Banner path={"HOME > MATERIAL TRANSFER VEHICLES / ROADTEC / SB-2500e "} />
//       <div className="custom-container">
//         <div className="font-bold test-[#161412] text-[12px] mt-[10px] text-[#161412]">{"<< BACK TO RESULTS"}</div>
//         <div className="grid grid-cols-1 md:grid-cols-6 gap-4 mt-[10px]">
//           <div className="col-span-1 md:col-span-2  block md:hidden">
//             <ListingCard />
//             <ContactForm />
//           </div>
//           <div className="col-span-1 md:col-span-4">
//             <MachineDetails />
//           </div>
//           <div className="col-span-1 md:col-span-2 hidden md:block">
//             <ListingCard />
//             <ContactForm />
//           </div>
//         </div>
//       </div>

//       <div className="col-span-1 md:col-span-4">
//         <SimilarMachines />
//       </div>
//       <Footer />
//     </>
//   );
// };
// export default Details;

// Back up code
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ContactForm from "../../components/details/contactForm";
import ListingCard from "../../components/details/listingCard";
import MachineDetails from "../../components/details/machineDetails";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import Banner from "../../components/search/banner";
import SimilarMachines from "../../components/search/similarMachines";
import { useEffect, useState } from "react";
import { getMachineDetailsByID } from "../../services/machineService";
import PageWrapper from "../../components/admin/layouts/PageWrapper/PageWrapper";

const Details = () => {
  const { state } = useLocation();
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [images, setImages] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const assetId = parseInt(params?.id?.split("-")?.at(-1));

    if (!assetId || isNaN(assetId)) {
      setNotFound(true);
      return;
    }

    setData([]);
    setImages([]);
    setNotFound(false);
    setIsLoading(true);
    window.scrollTo({ top: 0, behavior: "smooth" });

    getMachineDetailsByID(assetId)
      .then((res) => {
        const existingImages = res?.data?.images || [];
        const primary_image_info = { ...res?.data?.primary_image, order: -1 };

        const res_img_info = existingImages.find((item) => item.id === primary_image_info.id)
          ? existingImages.map((item) =>
              item.id === primary_image_info.id ? { ...item, order: -1 } : item
            )
          : [...existingImages, primary_image_info];

        const showImgList = res_img_info
          .sort((a, b) => a.order - b.order)
          .map((item) => ({
            image: item?.url,
            caption: "",
            assetAdvertisementId: item?.assetAdvertisementId,
            name: item?.name?.replaceAll(" ", "-"),
          }));

        setImages(showImgList);
        setData(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setNotFound(true);
        console.log(err);
      });
  }, [params.id]);

  const handelCategorizationBreadcrumb = (e) => {
    const categorizatioList = e;
    navigate(`/search`, {
      state: {
        keywords: null,
        selectMake: null,
        selectCategory: categorizatioList ? JSON.stringify([categorizatioList]) : "",
      },
    });
  };

  if (notFound) return (
    <PageWrapper name="Machine Detail">
      <Header />
      <div style={{ textAlign: "center", padding: "80px 24px" }}>
        <div style={{ fontSize: 20, fontWeight: 600, color: "#374151", marginTop: 8 }}>Machine not found</div>
        <button
          onClick={() => navigate("/")}
          style={{ marginTop: 24, background: "#FEBA06", border: "none", borderRadius: 8, padding: "12px 28px", fontWeight: 700, fontSize: 14, cursor: "pointer", color: "white" }}
        >
          Back to Home
        </button>
      </div>
      <Footer />
    </PageWrapper>
  );

  return (
    <PageWrapper name="Mchine Detail">
      <div id="equip-detail">
        <Header />
        <Banner
          path={
            data?.categorization?.asset_type && (
              <div>
                <span
                  onClick={() => {
                    navigate(`/`);
                  }}
                  className="cursor-pointer font-[roboto] text-[16px] text-[#161412] font-normal"
                >
                  HOME
                </span>

                {data?.categorization?.category?.name && (
                  <>
                    <span>{" > "}</span>
                    <span
                      onClick={() => {
                        handelCategorizationBreadcrumb({
                          CategoryId: Number(data?.categorization?.category?.id),
                          CategoryName: data?.categorization?.category?.name,
                        });
                      }}
                      className="cursor-pointer font-[roboto] text-[16px] text-[#161412] font-normal"
                    >
                      {data?.categorization?.category?.name}
                    </span>
                  </>
                )}

                <>
                  <span>{" / "}</span>
                  <span className="cursor-pointer  text-[16px]">
                    {data?.year}&nbsp;
                    {data?.model?.manufacturer?.name}&nbsp;
                    {data?.model?.number}
                  </span>
                </>
              </div>
            )
          }
        />
        <div className="custom-container">
          <div
            className="font-bold test-[#161412] text-[12px] mt-[10px] text-[#161412] cursor-pointer"
            onClick={() => {
              state?.selectCategory || state?.selectMake ? navigate("/search", { state }) : navigate(-1);
            }}
          >
            {"<< BACK TO RESULTS"}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-6 gap-4 mt-[10px]">
            <div className="col-span-1 md:col-span-2  block md:hidden">
              <ListingCard data={data} isLoading={isLoading} />
              <ContactForm />
            </div>
            <div className="col-span-1 md:col-span-4">
              <MachineDetails data={data} isLoading={isLoading} images={images} />
            </div>
            <div className="col-span-1 md:col-span-2 hidden md:block">
              <ListingCard data={data} isLoading={isLoading} />
              <ContactForm data={data} isLoading={isLoading} />
            </div>
          </div>
        </div>

        <div className="col-span-1 md:col-span-4 mt-[50px]">
          <SimilarMachines data={data} />
        </div>
        <Footer />
      </div>
    </PageWrapper>
  );
};
export default Details;
